import * as actionTypes from "../actions/actionTypes";

const projects = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.PROJECTSEARCHKEY:
      return { ...state, searchkey: action.payload };
    default:
      return state;
  }
};

export default projects;
